import { RequestStatus } from '../../Constants';
import { Map as ImmutableMap } from 'immutable';
const defaultState = {
  videoOptInStatus: ImmutableMap({}),
  openModal: null,
  fetchVideo2OptInStatusRequestStatus: RequestStatus.UNINITIALIZED,
  updateVideo2OptInStatusRequestStatus: RequestStatus.UNINITIALIZED
};
export const DefaultVideo2OptInStateMap = ImmutableMap(defaultState);